import { Directive } from '@angular/core';

@Directive({
  selector: '[myRedemptionLink]',
})
export class MyRedemptionLinkDirective {
  constructor() {}
}
